import { useEffect, useState } from "react";
import { apiMongo } from "../api/apiData";

type Mascot = {
  position: number;
  name: string;
  species: string;
  fact: string;
};

export const MascotCatalogPage = () => {
  const [catalog, setCatalog] = useState<Mascot[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCatalog = async () => {
      try {
        const response = await apiMongo.get(
          `${process.env.REACT_APP_MONGO_URL}/game/mascot-catalog`
        );
        setCatalog(response.data.catalog);
      } catch (error) {
        console.error("Cannot get mascot catalog:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCatalog();
  }, []);

  return (
    <div className="heroNotGame">
      <div className="mascot-catalog-page">
        <p className="title is-3 font-antonio">Seria I: Mini-maskotki 🐾</p>
        <p className="subtitle is-6">
          Każdy znacznik postawiony w grze to kolejna maskotka z tej serii —
          zawsze w tej samej, jawnej kolejności, nigdy losowo. Pierwszy
          znacznik zawsze daje pozycję #1, drugi #2, i tak dalej.
        </p>

        {isLoading ? (
          <p>Ładowanie serii...</p>
        ) : (
          <div className="mascot-catalog-grid">
            {catalog.map((mascot) => (
              <div className="mascot-catalog-card" key={mascot.position}>
                <p className="mascot-catalog-position">#{mascot.position}</p>
                <p className="mascot-catalog-name font-antonio">
                  {mascot.name}
                </p>
                <p className="mascot-catalog-species">{mascot.species}</p>
                <p className="mascot-catalog-fact">{mascot.fact}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
